import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=10fc3d00"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=10fc3d00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports